<template>
    <div>
        <div class="craft">
            <div class="part-one">
                <div class="base-title">
                    <div class="part-one-content">
                        <img class="part-one-title-img" src="../assets/imgs/craft/part-1-title.png" alt="" />
                        <div class="part-text part-one-text">
                            大力实施“成都工匠”培育五年计划，带动引领技能人才特别是高技能人才高质量、规模性增长，形成具有国际竞争力和区域带动力的现代产业工匠人才支撑体系。
                        </div>
                    </div>
                </div>
            </div>
            <div class="part-two">
                <img src="../assets/imgs/craft/part-2-title.png" class="part-two-title-img" />
                <!-- <div class="part-title part-two-title" style="margin-top: 1.44rem">
                    产业工人代表
                </div> -->
                <div class="part-two-content" style="margin-top: 1.44rem">
                    “成都工匠”主要指在成都重点产业具有工艺专长、掌握高超技能，技艺精湛、精益求精，严谨细致、专业敬业，长期坚守在生产服务一线岗位，并在本领域、行业内具有较高公认度和示范引领作用的产业工人代表。
                </div>
                <!-- <div class="part-title part-two-title">所有职工</div> -->
                <div class="part-two-content">
                    “成都工匠”申请对象面向本市所有职工（含农民工），重点聚焦现代化开放型产业体系中的一线工人，不受年龄、学历、资历和身份等限制。
                </div>
            </div>
            <div class="part-three">
                <img src="../assets/imgs/craft/part-3-title.png" class="part-two-title-img" />
                <div class="part-three-items" v-for="item in part3" :key="item.id" :style="item.boxHeight">
                    <img :src="item.title" class="part-three-items-img" />
                    <div class="part-three-items-text" :style="item.text ? item.text : ''">
                        {{ item.content }}
                    </div>
                </div>
                <div class="out-link">
                    （具体参见《成都市礼遇“成都工匠”十条政策措施》）
                </div>
            </div>
            <div class="part-four">
                <img src="../assets/imgs/craft/part-4-title.png" class="part-two-title-img" />
                <div class="part-title part-four-title">
                    如何申请“成都工匠”？
                </div>
                <div class="main-content">
                    <div class="part-four-items" v-for="item in part4" :key="item.id" :style="item.boxHeight">
                        <div :class="item.title">{{ item.label }}</div>
                        <div class="part-four-content1">
                            <span class="inside-title" v-if="item.content1.title">{{ item.content1.title }}</span>
                            {{ item.content1.text }}
                        </div>
                        <div class="part-four-content2" v-if="item.content2">
                            <span class="inside-title" v-if="item.content2.title">{{ item.content2.title }}</span>
                            {{ item.content2.text }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="contact">
                <img class="top" src="./../assets/imgs/label/contact4.png" alt="" />
                <div class="content">
                    <div class="number">
                        <span class="label">政策咨询电话：</span>
                        <div>
                            <a href="tel:028-81715145">028-81715145</a>
                        </div>
                    </div>
                    <div class="unit">
                        <span class="label">责任单位：</span>
                        市总工会经济技术和劳动保护部
                    </div>
                </div>
            </div>
            <div class="codes">
                <img class="code" src="../assets/imgs/craft/code.png" />
                <img class="text" src="../assets/imgs/craft/text.png" />
            </div>
        </div>
        <call phone="028-81715145"></call>
    </div>
</template>

<script>
// import bottom from '../components/bottom.vue'
import call from "../components/call.vue";

export default {
    name: "craft",
    components: {
        // bottom,
        call,
    },
    data() {
        return {
            part3: [
                {
                    id: 1,
                    title: require("../assets/imgs/craft/part3-1.png"),
                    content: "可获一次性2万元奖励",
                    boxHeight: "",
                },
                {
                    id: 2,
                    title: require("../assets/imgs/craft/part3-2.png"),
                    content: "按规定享受教育优待政策",
                    boxHeight: "",
                },
                {
                    id: 3,
                    title: require("../assets/imgs/craft/part3-3.png"),
                    content: "凭卡享受医疗、交通、保险、文体娱乐等服务保障",
                    boxHeight: "",
                },
                {
                    id: 4,
                    title: require("../assets/imgs/craft/part3-4.png"),
                    content:
                        "还可享受人才落户、便捷就医、交通出行、身心健康、保险保障、学习交流等相关政策支持",
                    boxHeight: "margin-bottom:0",
                    text: "text-align: left;",
                },
            ],
            part4: [
                {
                    id: 1,
                    title: "title-bg",
                    label: "推荐申报",
                    content1: {
                        title: "单位推荐：",
                        text: "企事业单位工会负责组织开展，择优推荐1—2人（本单位内最优秀），并指导被推荐人填写《“成都工匠” 推荐审批表》。企事业单位工会负责将本单位申报人材料报送至所在区（市）县总工会。",
                    },
                    content2: {
                        title: "个人申报：",
                        text: "个人申报需如实填写《“成都工匠”推荐审批表》（附件1），申报材料报送至所在区（市）县总工会进行初审，按照单位申报流程完成资格审核和公示。公示无异议后，由所在区（市）县总工会将其与单位申报人选一并推荐。",
                    },
                    boxHeight: "",
                },
                {
                    id: 2,
                    label: "资格审核",
                    title: "title-bg title-bg2",
                    content1: {
                        title: "",
                        text: "所在区（市）县总工会对申报对象进行初审、择优推荐至市总工会。市总工会对单位申报人员进行资格复核。",
                    },
                    content2: "",
                    boxHeight: "",
                },
                {
                    id: 3,
                    label: "专家评审",
                    title: "title-bg title-bg3",
                    content1: {
                        title: "",
                        text: "专家评审小组进行现场评审，由评审专家从工匠精神、精湛技艺等方面，对候选人员、集体按百分制进行现场评审打分；召开综合评审会议，确定候选建议名单。",
                    },
                    content2: "",
                    boxHeight: "",
                },
                {
                    id: 4,
                    label: "社会公示",
                    title: "title-bg title-bg4",
                    content1: {
                        title: "",
                        text: "",
                    },
                    content2: "",
                    boxHeight: "",
                },
                {
                    id: 5,
                    label: "领导小组审批",
                    title: "title-bg title-bg5",
                    content1: {
                        title: "",
                        text: "市总工会将 “成都工匠”候选人员名单提交市委人才工作领导小组审批。",
                    },
                    content2: "",
                    boxHeight: "",
                },
                {
                    id: 6,
                    label: "命名表扬",
                    title: "title-bg title-bg6",
                    content1: {
                        title: "",
                        text: "",
                    },
                    content2: "",
                    boxHeight: "height:0rem;border:none",
                },
            ],
        };
    },
    created() { },
    mounted() { },
    computed: {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.craft {
    background: #0839b7;
    overflow: hidden;
    padding: 0.24rem 0.12rem;
    padding-bottom: 1.65rem;
    box-sizing: border-box;
    width: 100vw;
    height: 100vh;
    overflow-y: auto;


    .part-title {
        font-size: 0.34rem;
        //font-family:: PingFang SC-Bold, PingFang SC;
        font-weight: bold;
        color: #333333;
        position: relative;

        &::before {
            position: absolute;
            content: "";
            width: 0.28rem;
            height: 0.28rem;
            border-radius: 50%;
            background: none;
            border: 0.06rem solid #ff6d60;
            box-sizing: border-box;
            top: 0.08rem;
            left: -0.28rem;
        }
    }

    .part-text {
        font-size: 0.26rem;
        //font-family:: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #4e4e4e;
        line-height: 0.44rem;
        text-align: left;
    }

    .part-one {
        width: 7.5rem;
        height: 7.2rem;
        margin: 0 auto;

        .base-title {
            width: 7.26rem;
            height: 5.6rem;
            background: url(../assets/imgs/craft/base-title.png);
            background-size: 100% 100%;
            position: relative;

            .part-one-content {
                width: 6.85rem;
                padding-bottom: 0.35rem;
                background: #ffffff;
                border-radius: 10px;
                position: absolute;
                top: 4.02rem;
                left: 0.22rem;
                padding-left: 0.36rem;
                padding-right: 0.37rem;
                box-sizing: border-box;

                .part-one-title-img {
                    position: absolute;
                    top: -0.32rem;
                    left: 0;
                    width: 6.86rem;
                    height: 1.12rem;
                }

                .part-one-title {
                    margin-top: 0.98rem;
                    text-align: left;
                    margin-left: 0.35rem;
                }

                .part-one-text {
                    margin-top: 1rem;
                }
            }
        }
    }

    .part-two-title-img {
        width: 7.03rem;
        height: 1.37rem;
        top: 0;
        left: -0.18rem;
        position: absolute;
    }

    .part-two {
        width: 6.85rem;
        background: #e8eeff;
        border-radius: 10px;
        padding-left: 0.33rem;
        padding-right: 0.3rem;
        box-sizing: border-box;
        position: relative;
        margin: 0 auto;
        margin-top: 0.22rem;
        border: 0.00001px solid transparent;

        .part-two-title {
            text-align: left;
            margin-left: 0.33rem;

            &::before {
                position: absolute;
                content: "";
                width: 0.28rem;
                height: 0.28rem;
                border-radius: 50%;
                background: none;
                border: 0.06rem solid #ff6d60;
                box-sizing: border-box;
                top: 0.08rem;
                left: -0.35rem;
            }
        }

        .part-two-content {
            margin-top: 0.2rem;
            margin-bottom: 0.3rem;
            width: 6.22rem;
            background: #ffffff;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 0.34rem 0.24rem 0.35rem 0.25rem;
            padding-bottom: 0.35rem;
            font-size: 0.26rem;
            //font-family:: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #4e4e4e;
            // line-height: 0.44rem;
            text-align: left;
            line-height: 0.44rem;

        }
    }

    .part-three {
        width: 6.85rem;
        // height: 10.66rem;
        background: #e8eeff;
        border-radius: 10px;
        margin: 0 auto;
        // margin-left: 0.02rem;
        margin-top: 0.22rem;
        box-sizing: border-box;
        position: relative;
        border: 0.00001px solid transparent;
        padding: 1.84rem 0.25rem 0 0.25rem;

        .part-three-items {
            width: 6.35rem;
            background: #ffffff;
            border-radius: 10px;
            padding-top: 0.68rem;
            padding-left: 0.31rem;
            padding-right: 0.31rem;
            box-sizing: border-box;
            position: relative;
            margin-bottom: 0.52rem;
            padding-bottom: 0.35rem;
            display: block;

            .part-three-items-text {
                font-size: 0.26rem;
                //font-family:: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #4e4e4e;
                text-align: center;
                line-height: 0.44rem;

            }

            .part-three-items-img {
                position: absolute;
                width: 3.74rem;
                height: 0.67rem;
                left: 50%;
                transform: translateX(-50%);
                top: -0.32rem;
            }
        }

        .out-link {
            margin-top: 0.35rem;
            margin-bottom: 0.35rem;
            font-size: 0.25rem;
            //font-family:: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #3d5aa3;
            text-align: center;
            text-decoration: none;
        }
    }

    .part-four {
        width: 6.85rem;
        background: #e8eeff;
        border-radius: 10px;
        margin-left: 0.02rem;
        margin-top: 0.22rem;
        box-sizing: border-box;
        display: inline-block;
        position: relative;
        padding: 1.44rem 0.25rem 0 0.25rem;

        .part-four-title {
            text-align: left;
            margin-left: 0.35rem;

            &::before {
                position: absolute;
                content: "";
                width: 0.28rem;
                height: 0.28rem;
                border-radius: 50%;
                background: none;
                border: 0.06rem solid #ff6d60;
                box-sizing: border-box;
                top: 0.08rem;
                left: -0.38rem;
            }
        }

        .main-content {
            margin-top: 0.34rem;
            width: 6.35rem;
            background: #ffffff;
            border-radius: 10px;
            box-sizing: border-box;
            padding-top: 0.8rem;
            padding-left: 0.35rem;
            padding-right: 0.31rem;

            .part-four-items {
                box-sizing: border-box;
                border-left: 0.02rem dashed #739bfe;
                margin-bottom: 0.6rem;
                padding-left: 0.33rem;
                padding-top: 0.2rem;
                padding-bottom: 0.35rem;
                position: relative;
                font-size: 0.26rem;
                //font-family:: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #4e4e4e;
                line-height: 0.44rem;
                text-align: left;

                .title-bg {
                    position: absolute;
                    width: 3.31rem;
                    height: 0.6rem;
                    top: -0.6rem;
                    left: -0.25rem;
                    display: inline-flex;
                    align-items: center;
                    font-size: 0.3rem;
                    //font-family:: PingFang SC-Bold, PingFang SC;
                    font-weight: bold;
                    line-height: 0.6rem;
                    color: #3d5aa3;
                    padding-left: 0.58rem;
                    background: url(../assets/imgs/craft/part4-1.png);
                    background-size: 100% 100%;
                }

                .title-bg2 {
                    background: url(../assets/imgs/craft/part4-2.png);
                    background-size: 100% 100%;
                }

                .title-bg3 {
                    background: url(../assets/imgs/craft/part4-3.png);
                    background-size: 100% 100%;
                }

                .title-bg4 {
                    background: url(../assets/imgs/craft/part4-4.png);
                    background-size: 100% 100%;
                }

                .title-bg5 {
                    background: url(../assets/imgs/craft/part4-5.png);
                    background-size: 100% 100%;
                }

                .title-bg6 {
                    background: url(../assets/imgs/craft/part4-6.png);
                    background-size: 100% 100%;
                }

                .inside-title {
                    font-weight: 800;
                }

                .part-four-content1 {
                    margin-bottom: 0.2rem;
                }
            }
        }
    }

    .codes {
        margin: 0 auto;
        margin-top: 0.25rem;
        width: 6.85rem;
        background: #fff;
        padding: 0.3rem;
        box-sizing: border-box;
        border-radius: 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        color: #4e4e4e;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .code {
            width: 1.94rem;
            height: 1.94rem;
        }

        .text {
            width: 4.5rem;
        }
    }
}
</style>
